class NewCampusModalController {

    constructor(
        NewCampusModalService
    ) {
        'ngInject'

        this.NewCampusModalService = NewCampusModalService;
        this.selectedCountry = undefined;
        this.newCampusName = undefined;
        this.countryList = this.resolve.countryList;
    }

    /***
     * Close the modal.
     */
    closeModal() {
        this.modalInstance.close();
    }

    setCountry(item) {
        this.selectedCountry = item;
    }

    /***
     * Triggered when the "Save" button on the modal is clicked. Updates the survey services for the current campus
     * and closes the modal if the save is successful.
     */
    saveModal() {
        this.NewCampusModalService.createCampus(this.resolve.clientId,
                                                this.newCampusName,
                                                this.selectedCountry.id)
            .then((successResponse) => {
                this.resolve.parentController.updateTree();
                this.modalInstance.close();
            }, (errorResponse) => {

            })
    }

}

export default NewCampusModalController;


// WEBPACK FOOTER //
// ./app/components/client-edit/new-campus-modal/new-campus-modal-controller.js